var render = function render(){var _vm=this,_c=_vm._self._c;return _c('label',{directives:[{name:"show",rawName:"v-show",value:(_vm.support),expression:"support"}],ref:"btn",staticClass:"uploader-btn"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }